import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { RouterService } from 'src/app/services/router-service.service';

@Component({
	selector: 'app-back-to-top-button',
	templateUrl: './back-to-top-button.component.html',
	styleUrls: ['./back-to-top-button.component.scss']
})
export class BackToTopButtonComponent implements AfterViewInit {

	bShowButton = false;
	@HostListener('window:scroll') private onScroll() {
		this.bShowButton = window.scrollY > window.innerHeight*0.8;
	};

	constructor(public routerService:RouterService) {}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.onScroll();
		}, 1);
	}
}
